import { c as _c } from "react/compiler-runtime";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { Balloon } from "@website/icons/components/balloon";
import { Hotel } from "@website/icons/components/hotel";
import { HotelInternational } from "@website/icons/components/hotel-international";
import { VentureBus } from "@website/icons/components/venture-bus";
import { VentureFlight } from "@website/icons/components/venture-flight";
import { VentureFlightInt } from "@website/icons/components/venture-flight-int";
import { VentureTrain } from "@website/icons/components/venture-train";
import { Villa } from "@website/icons/components/villa";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { useLoginModal } from "@website/widget/login";
import { useState } from "react";
const products: Record<string, string> = {
  "/": "DH",
  "/train": "Train",
  "/inter-flights": "IF",
  "/flights": "DF",
  "/villa": "Villa",
  "/bus": "Bus",
  "/bus-international": "IB",
  "/profile": "Profile",
  "/tour": "Tour"
};
export const useMyTrips = () => {
  const $ = _c(46);
  const [purchaseMenuIsOpen, setPurchaseMenuIsOpen] = useState(false);
  const router = useCompatRouter();
  const {
    onLoginModalOpen
  } = useLoginModal();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function onPurchaseMenuOpen() {
      window?.webengage?.track("mytrips-clicked", {
        source: process.env.NEXT_PUBLIC_APP_NAME
      });
      setPurchaseMenuIsOpen(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onPurchaseMenuOpen = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function onPurchaseMenuClose() {
      setPurchaseMenuIsOpen(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onPurchaseMenuClose = t1;
  const {
    isLoggedIn
  } = useLoginStatus();
  let t2;
  if ($[2] !== isLoggedIn || $[3] !== onLoginModalOpen || $[4] !== router) {
    t2 = (selectedService, event) => {
      window?.webengage?.track(event, {
        source: process.env.NEXT_PUBLIC_APP_NAME
      });
      const query = {
        ...router.query,
        my_trips_tab: "0",
        selected_service: selectedService,
        source: String(process.env.NEXT_PUBLIC_APP_NAME),
        product: products[router?.pathname] || ""
      };
      const queryString = new URLSearchParams(query).toString();
      const profileUrl = `/profile/my-trips${queryString ? `?${queryString}` : ""}`;
      if (isLoggedIn) {
        window.location.href = profileUrl;
      } else {
        onLoginModalOpen().then(() => {
          window.location.href = profileUrl;
        });
      }
    };
    $[2] = isLoggedIn;
    $[3] = onLoginModalOpen;
    $[4] = router;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onClickHandler = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Hotel />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onClickHandler) {
    t4 = {
      type: "button",
      title: "\u0647\u062A\u0644 \u062F\u0627\u062E\u0644\u06CC",
      icon: t3,
      onClick: () => onClickHandler("HOTEL", "DH-mytrips-clicked")
    };
    $[7] = onClickHandler;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <HotelInternational />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== onClickHandler) {
    t6 = {
      type: "button",
      title: "\u0647\u062A\u0644 \u062E\u0627\u0631\u062C\u06CC",
      icon: t5,
      onClick: () => onClickHandler("INTER_HOTEL", "IH-mytrips-clicked")
    };
    $[10] = onClickHandler;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onClickHandler) {
    t7 = () => onClickHandler("FLIGHT", "DF-mytrips-clicked");
    $[12] = onClickHandler;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <VentureFlight />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7) {
    t9 = {
      type: "button",
      onClick: t7,
      title: "\u067E\u0631\u0648\u0627\u0632 \u062F\u0627\u062E\u0644\u06CC",
      icon: t8
    };
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <VentureFlightInt />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== onClickHandler) {
    t11 = {
      type: "button",
      title: "\u067E\u0631\u0648\u0627\u0632 \u062E\u0627\u0631\u062C\u06CC",
      icon: t10,
      onClick: () => onClickHandler("INTER_FLIGHT", "IF-mytrips-clicked")
    };
    $[18] = onClickHandler;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== onClickHandler) {
    t12 = () => onClickHandler("BUS", "Bus-mytrips-clicked");
    $[20] = onClickHandler;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <VentureBus />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12) {
    t14 = {
      type: "button",
      onClick: t12,
      title: "\u0627\u062A\u0648\u0628\u0648\u0633",
      icon: t13
    };
    $[23] = t12;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <VentureTrain />;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== onClickHandler) {
    t16 = {
      type: "button",
      title: "\u0642\u0637\u0627\u0631",
      icon: t15,
      onClick: () => onClickHandler("TRAIN", "Train-mytrips-clicked")
    };
    $[26] = onClickHandler;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Villa />;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== onClickHandler) {
    t18 = {
      type: "button",
      title: "\u0648\u06CC\u0644\u0627",
      icon: t17,
      onClick: () => onClickHandler("VILLA", "Villa-mytrips-clicked")
    };
    $[29] = onClickHandler;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Balloon />;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== onClickHandler) {
    t20 = {
      type: "button",
      title: "\u062A\u0648\u0631",
      icon: t19,
      onClick: () => onClickHandler("TOUR", "Tour-mytrips-clicked")
    };
    $[32] = onClickHandler;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t11 || $[35] !== t14 || $[36] !== t16 || $[37] !== t18 || $[38] !== t20 || $[39] !== t4 || $[40] !== t6 || $[41] !== t9) {
    t21 = [t4, t6, t9, t11, t14, t16, t18, t20];
    $[34] = t11;
    $[35] = t14;
    $[36] = t16;
    $[37] = t18;
    $[38] = t20;
    $[39] = t4;
    $[40] = t6;
    $[41] = t9;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  const purchaseList = t21;
  let t22;
  if ($[43] !== purchaseList || $[44] !== purchaseMenuIsOpen) {
    t22 = {
      purchaseList,
      onPurchaseMenuOpen,
      onPurchaseMenuClose,
      purchaseMenuIsOpen
    };
    $[43] = purchaseList;
    $[44] = purchaseMenuIsOpen;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  return t22;
};